<template>
	<div id="bg">
		<div class="container">
			<div class="introduction">
				<div class="ititle">
					
				</div>
				<div class="icontent">
					
				</div>
			</div>
			<div class="login">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" label-width="0px" class="demo-ruleForm">
					<h3 class="title">登录平台</h3>
					<div id="div_Password">
						<el-form-item prop="account">
							<el-input type="text" v-model="ruleForm.account" auto-complete="off" placeholder="账号">
								<i slot="prefix" class="fa fa-user fa-lg"></i>
							</el-input>
						</el-form-item>
						<el-form-item prop="checkPass">
							<el-input type="password" v-model="ruleForm.checkPass" @keyup.enter.native="handleSubmit" auto-complete="off" placeholder="密码">
								<i slot="prefix" class="fa fa-key fa-lg" aria-hidden="true"></i>
							</el-input>
						</el-form-item>
						<el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>
						<a href="#" style="color: #FFFFFF;float: right;" @click="a_PassWord">扫码登陆</a>
						<el-form-item style="width:100%;margin-top: 20px;">
							<el-button type="success" style="width:100%;" @click.native.prevent="handleSubmit" :loading="logining">登录</el-button>
						</el-form-item>
					</div>
					<div id="div_SweepCode" style="display: none; text-align: center;">
						<div style="width: 150px;height: 150px;margin-left: 64px;" v-loading="SweepCode_load" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
							<img id="img_qrcode" src="" alt="" style="width: 150px;height: 150px">
							<br />
						</div>
						<a href="#" style="color: #FFFFFF;float: right;margin-top: 12px;" @click="a_SweepCode">密码登陆</a>
					</div>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	import { GetQrcode, GetSceneStr } from '../api/login';
	import { getToken, setToken, removeToken, setToken2 } from '@/utils/auth'
	export default {
		data() {
			return {
				logining: false,
				SweepCode_load: false,
				SceneStr: "",
				ruleForm: {
					account: '',
					checkPass: ''
				},
				rules: {
					account: [{
						required: true,
						message: '请输入账号',
						trigger: 'blur'
					}, ],
					checkPass: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}, ]
				},
				checked: true
			};
		},
		methods: {
			handleReset() {
				this.$refs.ruleForm.resetFields();
			},
			handleSubmit(ev) {
				var _this = this;
				this.$refs.ruleForm.validate((valid) => {
					if(valid) {
						this.logining = true;
						var loginParams = {
							userNo: this.ruleForm.account,
							passWord: this.ruleForm.checkPass
						};
						this.$store.dispatch('LoginByUserNo', loginParams).then((res) => {
							this.$router.push({
								path: '/'
							})
						}).catch(() => {
							this.logining = false;
						})
					} else {
						return false;
					}
				});
			},
			a_PassWord: function() {
				this.SweepCode_load = true;
				document.getElementById("div_Password").style.display = "none";
				document.getElementById("div_SweepCode").style.display = "block";
				let para = {
					companyno: "WL"
				};
				GetQrcode(para).then((res) => {
					this.SweepCode_load = false;
					document.getElementById("img_qrcode").src = res.data.urlFormat;
					this.SceneStr = res.data.str;
				}).catch((res) => {

				});
				
				var t1 = setInterval(() => {
					let para = {
						SceneStr: "SceneStr:" + this.SceneStr
					};
					GetSceneStr(para).then((result) => {
						var data = JSON.parse(result.data);
						if(data.state == 1) {
							this.$store.state.user.token = data.token;
							setToken(data.token);
							window.clearInterval(t1);
							this.$router.push({
								path: '/'
							})
						} else if(data.state == 2) {
							this.$message({
								message: result.msg,
								type: 'error'
							});
							window.clearInterval(t1);
						}
					}).catch((res) => {});

				}, 1000);
			},
			a_SweepCode: function() {
				this.SweepCode_load = false;
				document.getElementById("div_SweepCode").style.display = "none";
				document.getElementById("div_Password").style.display = "block";
				document.getElementById("img_qrcode").src = "";
			},
		},
		mounted() {
			function rnd(n, m) {
				var random = Math.floor(Math.random() * (m - n + 1) + n);
				return random;
			}
			var rand = rnd(1, 3);
			var imgurl;
			switch(rand) {
				case 1:
					imgurl = "url(" + require('../assets/bg1.jpg') + ")";
					break;
				case 2:
					imgurl = "url(" + require('../assets/bg2.jpg') + ")";
					break;
				default:
					imgurl = "url(" + require('../assets/bg3.jpg') + ")";
			}
			document.getElementById("bg").style.backgroundImage = imgurl;
		}
	}
</script>

<style lang="scss" scoped>
	#bg {
		background-color: #000000;
		bottom: 0px;
		top: 0px;
		left: 0px;
		right: 0px;
		position: absolute;
		background-image: url('../assets/bg3.jpg');
		background-repeat: no-repeat;
		background-size: 100%100%;
	}
	
	.container {
		margin: 0 auto;
		margin-top: 160px;
		max-width: 900px;
		height: 350px;
	}
	
	.introduction {
		width: 60%;
		padding-top: 10px;
		padding-left: 40px;
		padding-right: 40px;
		padding-bottom: 10px;
		height: 100%;
		float: left;
	}
	
	.login {
		padding-top: 10px;
		padding-left: 40px;
		padding-right: 40px;
		padding-bottom: 20px;
		width: 40%;
		float: left;
	}
	
	.ititle {
		color: white;
		font-size: 35px;
		text-align: center;
		margin-bottom: 24px;
	}
	
	.icontent {
		color: white;
		font-size: 20px;
		text-indent: 2em;
	}
	
	.login {
		background: rgba(0, 0, 0, 0.4);
		.title {
			text-align: center;
			font-size: 20px;
			color: white;
		}
	}
</style>